'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHocWithRef = require('react-hoc-with-ref');

var _reactHocWithRef2 = _interopRequireDefault(_reactHocWithRef);

var _Validator = require('../Validator');

var _Validator2 = _interopRequireDefault(_Validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (WrappedComponent) {
  return function (_createWithRef) {
    (0, _inherits3.default)(WithValidator, _createWithRef);

    function WithValidator() {
      (0, _classCallCheck3.default)(this, WithValidator);

      var _this = (0, _possibleConstructorReturn3.default)(this, _createWithRef.call(this));

      _this.state = { validatorToken: null };
      _this.validator = new _Validator2.default();
      _this.validator.attachComponent(_this);
      return _this;
    }

    WithValidator.prototype.render = function render() {
      return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, this.getRefProps(), {
        validator: this.validator,
        validatorToken: this.state.validatorToken
      }));
    };

    return WithValidator;
  }((0, _reactHocWithRef2.default)(WrappedComponent));
};
//# sourceMappingURL=withValidator.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-vld/lib/decorators/withValidator.js
// module id = 1255
// module chunks = 0